import { render } from "./Dataset.vue?vue&type=template&id=3c289c5d"
import script from "./Dataset.vue?vue&type=script&lang=js"
export * from "./Dataset.vue?vue&type=script&lang=js"

import exportComponent from "/Users/connorklaassen/Documents/Programming/cklaassen.github.io/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__